export { default } from './LlistatContingut';
